/* @flow */
import Collection from 'lib/Collection';
import PotentialChatMember from 'entities/PotentialChatMember';

class PotentialChatMembers extends Collection<PotentialChatMember> {
  initialize() {
    // $FlowIssue
    this.url = '/chats/members/search/';
    this.model = PotentialChatMember;
  }

  getAvailableMembers() {
    return this.filterToCollection(member => !member.isUnavailable());
  }

  filterToCollection(filter: (pcm: PotentialChatMember) => boolean) {
    return new PotentialChatMembers(this.filter(filter));
  }

  parse(response: Object) {
    return response.potential_chat_members;
  }
}

export default PotentialChatMembers;
